import { createApi } from 'api/common/createApi'

export const colliderApi = createApi({
  baseURL: process.env.REACT_APP_COLLIDER_API_URL,
})
